import {createStore, withProps} from '@ngneat/elf';
import {withEntities, withUIEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';
import {GridSortItem} from '@mui/x-data-grid-pro';

import {
  SuppliersService,
  SuppliersServicesFilters,
  SuppliersServiceUI
} from '@store/suppliers/services/suppliers-services.model';
import {TablePagination} from '@store/common/pagination.model';

import {TableConfig} from '@constants/table.constants';

export interface SuppliersServicesState {
  filters: SuppliersServicesFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
}

export const suppliersServicesStore = createStore(
  {name: 'suppliers-services'},
  withProps<SuppliersServicesState>({
    filters: {search: '', tableFilters: SuppliersServicesFilters.initTableFilters()},
    sort: {
      field: 'supplierOrgUnitService.supplierName',
      sort: 'asc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withEntities<SuppliersService>(),
  withUIEntities<SuppliersServiceUI>(),
  withPagination(),
  withRequestsStatus(),
);